var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout tx-map"},[_c('iframe',{attrs:{"id":"mapPage","width":"100%","height":"100%","frameborder":"0","src":'https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=VDEBZ-O22HK-DHHJU-AXDG5-AJGDZ-WXFEJ&referer=myapp&coord=' +
      _vm.lat +
      ',' +
      _vm.lon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }